// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal_wrapper__2qwAe","container":"modal_container__39nh3","innerlogo":"modal_innerlogo__2Dqva","socialicons":"modal_socialicons__1USEo"};